export const ImageData1 = [
    {
      "className": "m-1",
      "alt": "#1",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#2",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#3",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      "height": "40px"
    },
   
    {
      "className": "m-1",
      "alt": "#6",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#7",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#8",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#9",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#10",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#11",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#12",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#12",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#12",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#12",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#12",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#12",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#12",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/arduino/arduino-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#13",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      "height": "40px"
    },
    {
      "className": "m-1",
      "alt": "#14",
      "src": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg",
      "height": "40px"
    }
  ]